// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCurrency from '../../../../shared/components/labeled-currency';

const OtherCreditsValue = props =>
    <section className='other-credits-value'>
        <LabeledCurrency
            className='claim-value-header'
            data={props.otherCreditTotal}
            label='OTHER_CREDITS'
        />
        <LabeledCurrency
            data={props.travel}
            label='TRAVEL'
        />
        <LabeledCurrency
            data={props.nonTravel}
            label='NON_TRAVEL'
        />
    </section>;

OtherCreditsValue.displayName = 'OtherCreditsValue';
OtherCreditsValue.propTypes = {
    nonTravel: PropTypes.number,
    otherCreditTotal: PropTypes.number,
    travel: PropTypes.number
};

export default OtherCreditsValue;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-value/other-credits-value.js